/**
 * Canonical HVAC example narrative for T&M info modals.
 * Matches seeded job JOB-203 (Southbank Towers · HVAC Service) and realistic
 * FieldInsight service / product codes. Import these strings — do not invent
 * parallel examples in individual dictionary entries.
 */
export const TM_EX = {
  jobRef: 'JOB-203',
  jobTitle: 'Southbank Towers · Daikin VRV annual service',
  customer: 'Southbank Towers',
  site: '300 Wellington St, Perth WA 6000',
  visitDate: '02/05/2026',
  techLead: 'Alex Turner',
  techAssist: 'Sam Nolo',
  /** Senior HVAC technician service item */
  srCode: 'HVAC-SR',
  srLabel: 'Senior HVAC Technician',
  srCostHr: 65.0,
  srServiceHr: 150.0,
  srTotalHrs: 4.0,
  srBillHrs: 4.0,
  /** Apprentice assist */
  appCode: 'HVAC-APP',
  appLabel: 'HVAC Apprentice',
  appCostHr: 45.0,
  appServiceHr: 95.0,
  appTotalHrs: 2.25,
  appBillHrs: 1.5,
  /** Van stock */
  thrmCode: 'DAIKIN-THRM',
  thrmDesc: 'Daikin fan coil thermistor — indoor FCU-42',
  thrmCost: 18.0,
  thrmSell: 37.5,
  /** Refrigerant */
  gasCode: 'R410A-3KG',
  gasDesc: 'R410A refrigerant top-up — 3 kg cylinder',
  gasCost: 142.0,
  gasSell: 228.0,
  /** Expense */
  calloutCode: 'HVAC-CALLOUT',
  calloutDesc: 'After-hours call-out — rooftop plantroom access',
  calloutSell: 120.0,
  /** Supplier PO (Lyons-style HVAC parts — see seed PO-1192 family) */
  poId: 'PO-1192',
  poSupplier: 'Lyons Airconditioning Services',
  poDesc: 'Cabin pressuriser fitting kit LY-FK00147',
  poExGst: 3750.0,
  poMarkupPct: 35,
} as const;

export const fmtAud = (n: number) =>
  '$' + n.toLocaleString('en-AU', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
